<script>
import { mapGetters } from 'vuex';
import ArticlesApi from '@/api/articles';
import { debounce } from 'lodash';
import cancelablePromise from '../../../../utils/cancelable-promise';

export default {
  name: 'EditArticlesCommandables',
  data: () => ({
    loading: true,
    loading2: false,
    search: null,
    articles: []
  }),
  computed: {
    ...mapGetters({ numTiers: 'user/numTiers' }),
    articlesCommandables () {
      return this.articles.filter(a => a.artCommandable);
    },
    articlesNonCommandables () {
      return this.articles.filter(a => !a.artCommandable);
    }
  },
  watch: {
    search (val) {
      val && val.length >= 3 && this.searchArticles(val);
    }
  },
  created () {
    ArticlesApi.getArticlesModifiables(this.numTiers, null, true).then(
      articles => {
        this.articles = articles;
      }
    ).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    submit () {},
    toogleArticleCommandable (article) {
      this.loading = true;
      ArticlesApi.setArticleCommandable(article.numArticle, this.numTiers, !article.artCommandable)
        .then(() => {
          article.artCommandable = !article.artCommandable;
        }).finally(
          () => {
            this.loading = false;
          }
        );
    },
    searchArticlesApiCall: cancelablePromise((...args) => ArticlesApi.getArticlesModifiables(...args), 'canceled'),
    searchArticles: debounce(function (query) {
      this.loading2 = true;
      this.searchArticlesApiCall(this.numTiers, query, null).then(
        articles => {
          if (articles !== 'canceled') {
            this.articles = articles;
            this.loading2 = false;
          }
        }
      ).catch(err => {
        this.loading2 = false;
        throw err;
      });
    }, 300)
  }
};
</script>

<template>
  <v-main>
    <Loader v-if="loading" />
    <v-container
      fluid
      fill-height
    >
      <div
        v-if="isMobile"
        style="width:100%"
      >
        <h1 class="primary--text">
          Sélection article
        </h1>
        <v-form
          ref="form"
          @submit.prevent="submit"
        >
          <v-text-field
            v-model="search"
            :loading="loading2"
            label="Nom ou numéro d'article"
          />
        </v-form>

        <v-list v-if="articlesCommandables && articlesCommandables.length">
          <v-subheader> Articles ajoutés manuellement mais non encore commandés</v-subheader>
          <v-list-item-group>
            <v-list-item
              v-for="article in articlesCommandables"
              :key="article.numArticle"
              @click="toogleArticleCommandable(article)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ article.libelle }}</v-list-item-title>

                <v-list-item-subtitle>{{ article.numArticle }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-switch
                  v-model="article.artCommandable"
                  :name="'vs-t-'+article.numArticle"
                  hide-details
                  dense
                />
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-list>
          <v-subheader>Articles</v-subheader>
          <v-list-item-group v-if="articlesNonCommandables.length === 0">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-italic text--disabled">
                  {{ search ? 'Aucun article trouvé' : 'Recherchez un article' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
          <v-list-item-group>
            <v-list-item
              v-for="article in articlesNonCommandables"
              :key="article.numArticle"
              @click="toogleArticleCommandable(article)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ article.libelle }}</v-list-item-title>

                <v-list-item-subtitle>{{ article.numArticle }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-switch
                  v-model="article.artCommandable"
                  :name="'vs-f-'+article.numArticle"
                  hide-details
                  dense
                />
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
      <v-layout
        v-else
        id="p-layout-edit-articles"
        row
        align-center
        justify-center
      >
        <div class="card">
          <h1 class="primary--text">
            Sélection article
          </h1>
          <v-form
            ref="form"
            @submit.prevent="submit"
          >
            <v-text-field
              v-model="search"
              :loading="loading2"
              label="Nom ou numéro d'article"
            />
          </v-form>

          <v-list>
            <v-list-item-group v-if="articlesNonCommandables.length === 0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-italic text--disabled">
                    {{ search ? 'Aucun article trouvé' : 'Recherchez un article' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item-group>
              <v-list-item
                v-for="article in articlesNonCommandables"
                :key="article.numArticle"
                @click="toogleArticleCommandable(article)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ article.libelle }}</v-list-item-title>

                  <v-list-item-subtitle>{{ article.numArticle }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <div class="card">
          <h1 class="primary--text">
            Articles ajoutés manuellement mais non encore commandés
          </h1>
          <v-form style="opacity:0">
            <v-text-field />
          </v-form>
          <v-list>
            <v-list-item-group v-if="articlesCommandables .length === 0 && search">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-italic text--disabled">
                    Aucun article trouvé
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item-group>
              <v-list-item
                v-for="article in articlesCommandables"
                :key="article.numArticle"
                @click="toogleArticleCommandable(article)"
              >
                <v-list-item-icon><v-icon>mdi-chevron-left</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ article.libelle }}</v-list-item-title>

                  <v-list-item-subtitle>{{ article.numArticle }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </v-layout>
    </v-container>
  </v-main>
</template>

<style lang="scss" scoped>
.card{
  width: 500px;
  max-width: 100%;
  margin-right: 4vw;
  height: 100%;
  h1{
    height: 3em;
  }

  display: flex;
  flex-direction: column;
  .v-list{
    flex: 1;
    overflow-y: scroll;
  }
}

.v-main{
  margin: 2vw;
  padding: 1vw 1vw 3vw 1vw !important;
  background-color: #F4F8F9;
  min-height: 70vh;
  max-height: 85vh;
}

#p-layout-edit-articles{
  align-items: flex-start !important;
}

.v-subheader{
  text-transform: uppercase;
  padding: 0 5px;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .container{
    min-height: calc(100vh - 150px);
    overflow-y: scroll;
    align-items: flex-start !important;
  }
}

</style>
